import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, filter, map } from 'rxjs/operators';
import { Action } from 'redux';
import AppState from '../../state';
import { CreateArtistInviteSuccess } from '../../artist/action-creators';
import { CREATE_ARTIST_INVITE_SUCCESS } from '../../artist/actions';
import { UpdateField } from '@webapp/store/release/action-creators';

/**
 *
 * This effect creates collaborators after a successful Artist Invite
 *
 */

export const createCollaboratorsAfterInvite = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, CreateArtistInviteSuccess>(CREATE_ARTIST_INVITE_SUCCESS),
    filter(
      (action) => action.source?.type === 'ARTIST' || action.role === 'main'
    ),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.release.release?.id),
    map(([action, state]) => {
      return new UpdateField<'artists'>(
        'artists',
        [...(state.release.release?.artists as any)].concat({
          ...action.artist,
          role: action.role,
        })
      );
    })
  );
